import React from 'react'
import ContactForm from '../ContactFrom/ContactForm'
import { contactEmail, supportEmail } from '../../content/csp'

const Contactpage = () => {
  return (
    <section className="wpo-contact-pg-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1">
            <div className="office-info">
              <div className="row justify-content-center">
                <div className="col col-xl-6 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-email"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>Email</h2>
                      <p>{contactEmail}</p>
                      <p>{supportEmail}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wpo-contact-title">
              <h2>Talk with Common Sense Politics</h2>
              <p>
                Use this form for partnership conversations, press, or
                questions about CSPNow. If you represent an organization, tell
                us how you work with political moderates today.
              </p>
            </div>
            <div className="wpo-contact-form-area">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contactpage
